"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _rating = require("../../styles/rating");

var _EmptyStar = _interopRequireDefault(require("../../svg/EmptyStar"));

var _FilledStar = _interopRequireDefault(require("../../svg/FilledStar"));

var _theme = _interopRequireDefault(require("../../styles/theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _default = function _default(props) {
  var filledStarCount = parseInt(props.rating ? props.rating.toString().split(".")[0] : 0);
  var emptyStarCount = props.maxRating - filledStarCount;
  var _onClick = props.onClick;
  return /*#__PURE__*/_react["default"].createElement(_rating.StarContainer, null, Array.from({
    length: filledStarCount
  }, function (_, k) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: k,
      style: _extends({}, _onClick ? {
        cursor: "pointer"
      } : {}),
      onClick: function onClick() {
        _onClick && _onClick(k);
      }
    }, /*#__PURE__*/_react["default"].createElement(_FilledStar["default"], {
      color: _theme["default"]["default"].secondaryBanana,
      width: props.size || 11,
      height: props.size || 10
    }));
  }), Array.from({
    length: emptyStarCount
  }, function (_, k) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: k,
      style: _extends({}, _onClick ? {
        cursor: "pointer"
      } : {}),
      onClick: function onClick() {
        _onClick && _onClick(filledStarCount + k);
      }
    }, /*#__PURE__*/_react["default"].createElement(_EmptyStar["default"], {
      color: _theme["default"]["default"].grey,
      width: props.size || 11,
      height: props.size || 10,
      onClick: function onClick() {
        _onClick && _onClick(filledStarCount + k);
      }
    }));
  }));
};

exports["default"] = _default;
module.exports = exports["default"];